import { useSelector } from "react-redux";

export default function useHasPermissionForAction(requiredPermission) {
  const { user } = useSelector((state) => state.auth);
  
  const hasPermission = user?.permissions?.some(
    (perm) => perm.name === requiredPermission
  );

  return hasPermission; 
}
